export function Footer() {
  return (
    <footer className="flex justify-center py-4 text-xs border-t-neutral border-t-2 bg-base-200">
      <span>© elan medoff</span>
    </footer>
  );
}
